import { gql } from 'graphql-tag';
import get from 'lodash.get';
import { useRouteMatch } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { projectTotalsFragment } from '~/modules/resourcing/common/fragments';

import { ResourceRequestStatus, ResourceAllocationStatus } from '~/types';

export const ALLOCATION_STATUS_LIST = [
  ResourceAllocationStatus.Committed,
  ResourceAllocationStatus.Proposed,
  ResourceAllocationStatus.Rejected,
  ResourceAllocationStatus.Draft
];

export const RESOURCE_REQUEST_STATUS_LIST = [
  ResourceRequestStatus.Draft,
  ResourceRequestStatus.Rejected,
  ResourceRequestStatus.Submitted,
  ResourceRequestStatus.Tobehired
];

export const projectTotalsQuery = gql`
  query getProjectTotalsBySlug(
    $projectSlug: String!
    $allocationStatusList: [ResourceAllocationStatus!]!
    $requestStatusList: [ResourceRequestStatus!]!
    $filter: ProjectTotalsFilter
  ) {
    project(projectSlug: $projectSlug) {
      ...ProjectTotalsFragment
    }
  }
  ${projectTotalsFragment}
`;

export const useProjectTotals = ({ filter }) => {
  const {
    params: { slug }
  } = useRouteMatch();

  const { loading, data, error } = useQuery(projectTotalsQuery, {
    variables: {
      projectSlug: slug,
      allocationStatusList: ALLOCATION_STATUS_LIST,
      requestStatusList: RESOURCE_REQUEST_STATUS_LIST,
      filter
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  });

  const project = get(data, 'project', {});

  const allocationsTotals = get(project, 'allocationsTotals', {});
  const resourceRequestsTotals = get(project, 'resourceRequestsTotals', {});

  return {
    error,
    loading,
    allocationsTotals,
    resourceRequestsTotals
  };
};
